import BaseDocumentHead, { IDocumentHead } from 'components/DocumentHead'
import { getWordsFromParagraph } from 'helpers/meta'
import { inject } from 'helpers/mobx'
import React, { FC } from 'react'
import { NormalizedStoryTextElement } from 'services/providers/iris/entities/stories/storyRows/storyRow.normalizer.types'
import { normalizeHreflangs } from 'store/normalizer/meta.normalizer'
import TrackStoryPageView from '../../TrackStoryPageView'

const MAX_TITLE_SYMBOLS_NUMBER = 60

const DocumentHead: FC<Partial<IDocumentHead>> = props => {
  return (
    <>
      <TrackStoryPageView pageTitle={props.title || ''} />
      <BaseDocumentHead {...props} />
    </>
  )
}

export default inject(store => {
  const t = store.t
  const story = store.storyPageStore.story
  const seo = store.storyPageStore.seo
  const brandCount = store.configStore.brandCount

  const returnDays =
    store.configStore.data.return && store.configStore.data.return.days

  let title = 'ABOUT YOU'

  if (story) {
    title = story.subline
      ? `${story.subline}: ${story.headline} | ABOUT YOU`
      : `${story.headline} | ABOUT YOU`
  }

  switch (story?.entityType) {
    case 'brand':
      {
        const firstRow = store.storyPageStore.storyRows[0]

        const firstParagraph =
          firstRow?.type !== 'idol-story-outfit-header'
            ? (firstRow?.elementRows.find(
                ([element]) => element.type === 'text',
              )?.[0] as NormalizedStoryTextElement | undefined)
            : undefined

        const firstWords = getWordsFromParagraph(
          MAX_TITLE_SYMBOLS_NUMBER - title?.length,
          firstParagraph?.text ?? '',
        )
        title = firstWords ? `${firstWords}... ${title}` : title
      }

      break
    case 'idol':
      title = t('{{idolName}} Outfits | ABOUT YOU', {
        idolName: story.headline,
      })
      break
  }

  let description = ''
  if (story && story.entityType === 'idol') {
    description = t(
      '{{idolName}} Outfits - Exklusive Fashion zum kleinen Preis. Bestelle versandkostenfrei im Online Shop bei ABOUT YOU. ✓Zahlung auf Rechnung',
      {
        idolName: story.headline,
      },
    )
  }

  if (story && story.entityType === 'category') {
    description = t(
      '{{headline}} - Exklusive Fashion versandkostenfrei im Online Shop bei ABOUT YOU bestellen ✓Kostenlose & schnelle Lieferung ✓Über {{brandCount}} Marken ✓{{returnDays}} Tage Rückgaberecht ✓Schnelle Lieferzeit ✓ Kostenlose Retoure ✓ Zahlung auf Rechnung ✓ Große Auswahl ✓ Top-Marken',
      {
        headline: story.headline,
        brandCount,
        returnDays,
      },
    )
  }

  const hreflangs = normalizeHreflangs(seo.hreflangs)

  const links = [...hreflangs]
  const shouldRenderAlternatesAndIndex =
    store.storyPageStore.pagination.currentPage === 1 &&
    !store.urlManagerStore.params.category

  return {
    title,
    description,
    renderHreflangs: shouldRenderAlternatesAndIndex,
    renderMobileAlternate: shouldRenderAlternatesAndIndex,
    links,
    robots: 'index, follow',
    customTitleTemplate: true,
  }
})(DocumentHead)
